var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.congHuaKindergarten
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page congHuaKindergarten-page",
            attrs: { id: "print_congHuaKindergarten" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "23px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                      "margin-top": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.congHuaKindergarten.reportName
                                    ? _vm.model.congHuaKindergarten.reportName
                                    : "幼儿园体检报告单"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "30px",
                        border: "none",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "18%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.congHuaKindergarten.name
                                  ? _vm.model.congHuaKindergarten.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "13%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.congHuaKindergarten.sex
                                  ? _vm.model.congHuaKindergarten.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "23%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("出生日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.congHuaKindergarten.birthday
                                  ? _vm.model.congHuaKindergarten.birthday
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "20%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.congHuaKindergarten.className
                                  ? _vm.model.congHuaKindergarten.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("体检日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.congHuaKindergarten.checkDate
                                  ? _vm.model.congHuaKindergarten.checkDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _vm._m(0),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高(CM)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.height
                                ? _vm.model.congHuaKindergarten.height
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.heightAssessment
                                ? _vm.model.congHuaKindergarten.heightAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血红蛋白值(g/L)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.hemoglobinValue
                                ? _vm.model.congHuaKindergarten.hemoglobinValue
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重(kg)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.weight
                                ? _vm.model.congHuaKindergarten.weight
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.weightAssessment
                                ? _vm.model.congHuaKindergarten.weightAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("视力(左/右)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.leftEyeVision
                                ? _vm.model.congHuaKindergarten.leftEyeVision
                                : ""
                            ) +
                              " / " +
                              _vm._s(
                                _vm.model.congHuaKindergarten.rightEyeVision
                                  ? _vm.model.congHuaKindergarten.rightEyeVision
                                  : ""
                              )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身长别体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.bmiAssessment
                                ? _vm.model.congHuaKindergarten.bmiAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体格发育评价")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten
                                .physicalDevelopmentAssessment
                                ? _vm.model.congHuaKindergarten
                                    .physicalDevelopmentAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("牙齿数量(颗)")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.numberTeeth !=
                                null ||
                                _vm.model.congHuaKindergarten.numberTeeth == 0
                                ? _vm.model.congHuaKindergarten.numberTeeth
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("发育评估")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten
                                .developmentaAssessment
                                ? _vm.model.congHuaKindergarten
                                    .developmentaAssessment
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("龋齿")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.cariesTotalNumber !=
                                null ||
                                _vm.model.congHuaKindergarten
                                  .cariesTotalNumber == 0
                                ? _vm.model.congHuaKindergarten
                                    .cariesTotalNumber
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("是否高危儿")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.highRiskChildren
                                ? _vm.model.congHuaKindergarten.highRiskChildren
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心肺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.heart
                                ? _vm.model.congHuaKindergarten.heart
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("腹部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.abdomen
                                ? _vm.model.congHuaKindergarten.abdomen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("高危因素")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.highRiskFactors
                                ? _vm.model.congHuaKindergarten.highRiskFactors
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体格检查其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.physicalCheckOther
                                ? _vm.model.congHuaKindergarten
                                    .physicalCheckOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("转诊原因")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.reasonReferral
                                ? _vm.model.congHuaKindergarten.reasonReferral
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.other
                                ? _vm.model.congHuaKindergarten.other
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._m(1),
                  _c("tr", { staticStyle: { "line-height": "25px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("听力筛查情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "160px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.listening
                                ? _vm.model.congHuaKindergarten.listening
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "110px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("屈光筛查情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "130px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                          "white-space": "normal",
                          "word-break": "break-all",
                          "line-height": "1.4",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.congHuaKindergarten.refraction
                                ? _vm.model.congHuaKindergarten.refraction
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._m(2),
            _c(
              "table",
              {
                staticStyle: {
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "margin-top": "10px",
                  "font-size": "16px",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "30px", border: "none" } },
                    [
                      _c("td", { staticStyle: { width: "45%" } }),
                      _c("td", [
                        _vm._v(
                          "体检机构：" +
                            _vm._s(
                              _vm.model.congHuaKindergarten.hospitalName
                                ? _vm.model.congHuaKindergarten.hospitalName
                                : ""
                            )
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "line-height": "30px" } }, [
      _c(
        "td",
        {
          staticStyle: {
            width: "100px",
            "border-collapse": "collapse",
            border: "1px solid black",
          },
        },
        [_vm._v("检查项目")]
      ),
      _c(
        "td",
        {
          staticStyle: {
            width: "80px",
            "border-collapse": "collapse",
            border: "1px solid black",
          },
        },
        [_vm._v("结果")]
      ),
      _c(
        "td",
        {
          staticStyle: {
            width: "80px",
            "border-collapse": "collapse",
            border: "1px solid black",
          },
        },
        [_vm._v("评价")]
      ),
      _c(
        "td",
        {
          staticStyle: {
            width: "110px",
            "border-collapse": "collapse",
            border: "1px solid black",
          },
        },
        [_vm._v("检查项目")]
      ),
      _c(
        "td",
        {
          staticStyle: {
            width: "130px",
            "border-collapse": "collapse",
            border: "1px solid black",
          },
        },
        [_vm._v("结果")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "line-height": "25px" } }, [
      _c(
        "td",
        {
          staticStyle: {
            width: "100px",
            "border-collapse": "collapse",
            border: "1px solid black",
            "font-weight": "bold",
            "text-align": "center",
            "letter-spacing": "2px",
          },
          attrs: { colspan: "5" },
        },
        [
          _vm._v(
            "上面都是免费国家基本公共卫生项目 0 至 6 岁儿童健康管理服务内容"
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticStyle: {
          width: "100%",
          "border-collapse": "collapse",
          border: "none",
          "margin-top": "10px",
          "font-size": "16px",
        },
      },
      [
        _c("tbody", [
          _c("tr", { staticStyle: { "line-height": "30px", border: "none" } }, [
            _c("td", { staticStyle: { width: "35%" } }),
            _c("td", [
              _vm._v("体检结果建议：详见集体儿童体检异常告知！谢谢合作"),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }